import { methods } from '@/plugin/mixin/methods'
import { data } from '@/plugin/mixin/data'

export const Mixin = { data, methods }


